import * as React from 'react';
import { Box, Grid, styled, Typography } from '@mui/material';
import { CardViewTextRowValue } from 'ui/viewComponents';
import { getZonesString, isExpandedLocationZone } from '../helpers';
import { ILocationZones } from '../models/LocationModel';

interface ILocationTablesAndZonesCardComponentProps {
    zones: ILocationZones;
}

const StyledBox = styled(Box)(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
}));

export const LocationTablesAndZonesCardComponent: React.FC<ILocationTablesAndZonesCardComponentProps> = ({
    zones
}) => {
    const zoneKeys = React.useMemo(() => Object.keys(zones ?? {}), [zones]);

    const renderZoneRow = React.useCallback(
        (zoneKey: string) => {
            const zonalAztec = isExpandedLocationZone(zones[zoneKey])
                ? zones[zoneKey]?.zonalAztec
                : undefined;
            return (
                <StyledBox key={zoneKey}>
                    <Typography>
                        <b>{zoneKey}</b>
                    </Typography>
                    <Typography variant="body2">Table Numbers: {getZonesString(zones[zoneKey])}</Typography>
                    {zonalAztec && (
                        <>
                            {zonalAztec?.salesAreaIdItems && (
                                <Typography variant="body2">
                                    Sales Area ID Items: {zonalAztec.salesAreaIdItems}
                                </Typography>
                            )}
                            {zonalAztec?.salesAreaIdDiscounts && (
                                <Typography variant="body2">
                                    Sales Area ID Discounts: {zonalAztec.salesAreaIdDiscounts}
                                </Typography>
                            )}
                            {zonalAztec?.salesAreaIdPayments && (
                                <Typography variant="body2">
                                    Sales Area ID Payments: {zonalAztec.salesAreaIdPayments}
                                </Typography>
                            )}
                        </>
                    )}
                </StyledBox>
            );
        },
        [zones]
    );

    return (
        <Grid container>
            {!!zoneKeys.length ? (
                <Grid item xs={12}>
                    {zoneKeys.map(renderZoneRow)}
                </Grid>
            ) : (
                <Grid item xs={12}>
                    <CardViewTextRowValue value="You have no zones configured" />
                </Grid>
            )}
        </Grid>
    );
};
